






import {Component} from "vue-property-decorator"
import AbpBase from "../../../lib/abpbase"

@Component
export default class Blood extends AbpBase{
	year = new Date()
	loading = false
	columns = [
		{title: '姓名',width:160,fixed: 'left'},
		{title: '转铁蛋白饱和度',width: 130},
		{title: '钙磷乘积',width: 130},
		{title: 'eKt/V',width: 130},
		{title: 'NPCR',width: 130},
		{title: 'spKt/V',width: 130},
		{title: 'URR',width: 130},
		{title: '红细胞比容',width: 130},
		{title: '血红蛋白',width: 130},
		{title: '铁蛋白',width: 130},
		{title: '甲状旁腺激素',width: 130},
		{title: '碱性磷酸酶',width: 130},
		{title: '磷',width: 130},
		{title: '钙',width: 130},
		{title: '前白蛋白',width: 130},
		{title: '白蛋白',width: 130},
		{title: '透前肌酐',width: 130},
		{title: '低密度脂蛋白胆固醇',width: 130},
		{title: '甘油三酯',width: 130},
		{title: '胆固醇',width: 130},
		{title: '高密度脂蛋白胆固醇',width: 130},
		{title: '空腹C肽',width: 130},
		{title: '空腹胰岛素',width: 130},
		{title: '空腹血糖',width: 130},
		{title: '糖化血红蛋白',width: 130},
		{title: 'C反应蛋白',width: 130},
		{title: '中性粒细胞百分比',width: 130},
		{title: '嗜酸细胞',width: 130},
		{title: '白细胞',width: 130},
		{title: '超敏C-反应蛋白',width: 130}
	]
	data = []
	async created(){
		this.getData()
	}

	getData(){
		this.loading = true
		setTimeout(()=>{
			this.loading = false
		},500)
	}
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/report/stageEvaluation/index.vue